import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from "react-i18next";

import TextToTextFile from './TextToTextFile';

// import { textToFile } from '../../../utils/text-util';

import { marks } from '../../../utils/marks';
import './TextToText.css';


const TextToTextResponse = (props) => {
  const { responseText } = props;

  const [t] = useTranslation("translation");

  const [text, setText] = useState('');
  const [replacedText, setReplaceText] = useState('');
  const [showCopied, setShowCopied] = useState(false);

  let detectedLanguage = navigator.languages[0];
  const lsUserSelectLng = localStorage.getItem('userSelectLng');

  if (lsUserSelectLng) {
    detectedLanguage = lsUserSelectLng;
  }

  useEffect(() => {
    if (responseText) {
      setText(responseText);
      let newText = responseText.replaceAll("**", " ");
      newText = newText.replaceAll("###", " ");
      setReplaceText(newText);

    }

  },[responseText]);


const handleSpeak = () => {
    // Create a new instance of SpeechSynthesisUtterance with your text
    const utterance = new SpeechSynthesisUtterance(replacedText);
    
    // Optional: Customize voice characteristics
    utterance.pitch = 1; // 0 to 2
    utterance.rate = 1;  // 0.1 to 10
    utterance.volume = 1; // 0 to 1
    // utterance.lang = 'en-US';
    
    if (detectedLanguage) {
      utterance.lang = detectedLanguage;
    }
    // console.log('detectedLanguage', detectedLanguage)

    // Use the window.speechSynthesis to speak the text
    window.speechSynthesis.speak(utterance);
  };

  const copyTextHandler = (text) => {
    navigator.clipboard.writeText(text);

    setShowCopied(true);

    setTimeout(() => {
      setShowCopied(false);
    }, 3000);
  };


  return (
    <Fragment>
      {replacedText && (
        <div>
          <div className='textToTextRow'>
            <div className='textToTextResponse'>
              <div className='textToTextResponseText'>
                {replacedText}
              </div>

              {/* <button onClick={handleSpeak}>Speak Text</button> */}
              <div className='sttLongTimeResponseCopy'>
                <span
                  onClick={() => {
                    copyTextHandler(replacedText)
                  }}
                >
                  {marks.copyMark}
                </span>
                {showCopied && (
                  <span>
                    {' '}({t("textVoiceAssistant09", "copied")})
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className='textToTextRow'>
            <TextToTextFile 
              replacedText={replacedText}
            />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default TextToTextResponse;